import React, { Component } from 'react';
import PaymentHeader from './Headers/PaymentHeader';
import AccountsReceivableHeader from './Headers/AccountsReceivableHeader';
// esto es un intento de factory


class FactoryHeader extends Component {

    getHeader = () => {
        const { props } = this.props
        const { view } = props
        let header = <></>
        switch (view) {
            case 'payment':
            case 'outgoingPayment':
                header = <PaymentHeader
                    {...this.props}
                />
                break;
            case 'AccountsReceivable':
                header = <AccountsReceivableHeader
                    {...this.props}
                />
                break;

            default:
                header = null
                break;
        }
        return header

    }
    render() {
        return (
            this.getHeader()
        );
    }
}

export default FactoryHeader;
